<template>
  <div class="add__lab_test">
    <vs-card>
      <!-- form notice -->
      <div class="form_notice text-center text-danger font-bold text-sm">
        <p>If you need any assistance filling in this form, please email us at support@seedsuite.us</p>
      </div>

      <!-- form -->
      <div class="lab_test__form mt-8">
        <!-- form header -->
        <div class="form__header text-center text-2xl font-black">Labs Order Form</div>

        <!-- step - form -->
        <div class="form__wizard">
          <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" @on-complete="addNewLabTest">
            <!-- Step - 1 -->
            <tab-content title="Step 1" class="mb-5" :lazy="true" :before-change="validateStep1">
              <AddTestStep1 ref="step1" :step1.sync="step1" />
            </tab-content>

            <!-- step - 2 -->
            <tab-content title="Step 2" class="mb-5" :lazy="true" :before-change="validateStep2">
              <AddTestStep2 :fetchLabList="fetchLabList" ref="step2" :step2.sync="step2" />
            </tab-content>

            <!-- step - 3 -->
            <tab-content title="Step 3" class="mb-5" :lazy="true">
              <AddTestStep3 ref="step3" :step3.sync="step3" :step2.sync="step2" />
            </tab-content>
          </form-wizard>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import AddTestStep1 from '@/views/lab-tests/components/AddTestStep1.vue'
import AddTestStep2 from '@/views/lab-tests/components/AddTestStep2.vue'
import AddTestStep3 from '@/views/lab-tests/components/AddTestStep3.vue'

export default {
  name: 'AddLabTest',

  components: {
    FormWizard,
    TabContent,
    AddTestStep1,
    AddTestStep2,
    AddTestStep3
  },

  data() {
    return {
      fetchLabList: false,
      step1: {
        batch: null,
        category: null,
        product_name: null
      },
      step2: {
        lab: null
      },
      step3: {
        checkNote: null,
        checkScheduleContact: null
      }
    }
  },

  async mounted() {
    await this.get_parent_user()
  },

  computed: {
    ...mapState('lab_test', {
      parent_user: 'parent_user',
      loading: 'loading'
    }),
    ...mapState('lab', {
      labProducts: 'labProducts',
      loading1: 'loading'
    }),

    calculateTotal() {
      return this.labProducts.reduce((acc, item) => {
        const tempTotal = item.price * Number(item.quantity)
        return acc + tempTotal
      }, 0)
    }
  },
  methods: {
    ...mapActions('lab_test', { fetchParentUser: 'getParantUser', add_new_lab_test: 'addLabTest' }),
    ...mapMutations('lab', { resetLabProducts: 'CLEAR_LAB_PRODUCTS' }),

    // get parent user
    async get_parent_user() {
      try {
        await this.fetchParentUser()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    async validateStep1() {
      if (!(await this.$refs.step1.$validator.validateAll())) {
        return false
      }

      this.fetchLabList = true
      return true
    },
    async validateStep2() {
      if (!(await this.$refs.step2.$validator.validateAll())) {
        return false
      }

      let totalQty = 0
      for (const labProduct of this.labProducts || []) {
        const quantity = labProduct.quantity
        totalQty += parseFloat(quantity)
      }

      if (!totalQty) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please enter quantity into aleast one product.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      return true
    },

    // add new lab test
    async addNewLabTest() {
      if (!this.step3.checkNote) {
        this.$vs.notify({
          title: 'Error',
          text: 'To proceed, please check the box',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        this.$refs.step3.$refs.checkNote.$el.querySelector('input').focus()

        return false
      }

      if (!this.step3.checkScheduleContact) {
        this.$vs.notify({
          title: 'Error',
          text: 'To proceed, please check the box',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        this.$refs.step3.$refs.checkScheduleContact.$el.querySelector('input').focus()

        return false
      }

      // request obj
      const create_labtest = {}

      // parent user details
      create_labtest.labId = this.step2.lab
      create_labtest.business_name = this.parent_user.business_name
      create_labtest.license_number = this.parent_user.omma_license_number
      create_labtest.first_name = this.parent_user.firstname
      create_labtest.last_name = this.parent_user.lastname
      create_labtest.phone = Number(this.parent_user.mobile)
      create_labtest.email = this.parent_user.email
      create_labtest.address = this.parent_user.address
      create_labtest.cityId = this.parent_user.cityId
      create_labtest.state = this.parent_user.state
      create_labtest.zipCode = this.parent_user.zipcode

      // test details
      create_labtest.batchId = this.step1.batch
      create_labtest.product_name = this.step1.product_name
      create_labtest.categoryId = this.step1.category

      // total
      create_labtest.total = this.calculateTotal

      // test products
      const labProducts = []
      this.labProducts.forEach(element => {
        const tempProduct = {}

        tempProduct.labProductId = element.id
        tempProduct.product_name = element.product_name
        tempProduct.quantity = element.quantity
        tempProduct.unit_price = element.price
        tempProduct.sub_total = element.price * Number(element.quantity)

        labProducts.push(tempProduct)
      })

      create_labtest.labProducts = labProducts

      try {
        const { message } = await this.add_new_lab_test(create_labtest)

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.resetLabProducts() // reset the lab products
        this.$router.push({ name: 'lab-test-list' })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  // watchers
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.add__lab_test',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('.add__lab_test > .con-vs-loading')
      }
    },

    loading1() {
      if (this.loading) {
        this.$vs.loading({
          container: '.add__lab_test',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('.add__lab_test > .con-vs-loading')
      }
    }
  }
}
</script>

<style></style>
